import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  drawerHandle: {
    width: 30,
    height: 4,
    backgroundColor: "#D2D1D2",
    borderRadius: 6,
    position: "absolute",
    top: 8,
    left: "calc(50% - 15px)",
  },
}));
